import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from 'react';
import classNames from 'classnames';
import { scFileIconContainerStyle, scFileIconPlayButtonStyle, scFileIconShortCutStyle, scFileIconStyle } from "./style";
export var FileIconSize = /*#__PURE__*/function (FileIconSize) {
  FileIconSize[FileIconSize["Small"] = 16] = "Small";
  FileIconSize[FileIconSize["Default"] = 32] = "Default";
  FileIconSize[FileIconSize["Large"] = 64] = "Large";
  return FileIconSize;
}({});
export var Icon = function Icon(_ref) {
  var src = _ref.src,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? FileIconSize.Default : _ref$size,
    className = _ref.className,
    style = _ref.style,
    _ref$stickerConfig = _ref.stickerConfig,
    stickerConfig = _ref$stickerConfig === void 0 ? {
      shortcut: false,
      playButton: false
    } : _ref$stickerConfig,
    children = _ref.children,
    onClick = _ref.onClick;
  var sizeStyle = {
    height: "".concat(size, "px"),
    width: "".concat(size, "px")
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('sc-file-icon-container', className),
    style: _objectSpread(_objectSpread(_objectSpread({}, scFileIconContainerStyle), sizeStyle), style),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "sc-file-icon",
    style: _objectSpread(_objectSpread({}, scFileIconStyle), {}, {
      backgroundImage: "url(".concat(src, ")")
    })
  }), stickerConfig.playButton && /*#__PURE__*/React.createElement("div", {
    style: _objectSpread({}, scFileIconPlayButtonStyle)
  }), stickerConfig.shortcut && /*#__PURE__*/React.createElement("div", {
    style: _objectSpread({}, scFileIconShortCutStyle)
  }), children);
};
//# sourceMappingURL=icon.js.map